module.exports = __webpack_public_path__ + "img/hat_5.21ff30ba.png";